import { useEffect, useState } from 'react';

const useScreenSize = () => {
  const [screenWidth, setScreenWidth] = useState(document.body.clientWidth);

  useEffect(() => {
    /* Reference for using resize event listener and debounce mechanism
    https://dev.to/vitaliemaldur/resize-event-listener-using-react-hooks-1k0c */
    let debounceResize: ReturnType<typeof setTimeout> = null;
    function handleResize() {
      // prevent execution of previous setTimeout
      clearTimeout(debounceResize);
      // change width from the state object after 50 milliseconds
      debounceResize = setTimeout(() => {
        setScreenWidth(document.body.clientWidth);
      }, 50);
    }
    // set resize listener
    window.addEventListener('resize', handleResize);
    // clean up function
    return () => {
      // remove resize listener
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  return screenWidth;
};

export default useScreenSize;
